import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var LeadFromExternal = /*#__PURE__*/function (_lm$Composant) {
  function LeadFromExternal(id) {
    var _this;
    _classCallCheck(this, LeadFromExternal);
    _this = _callSuper(this, LeadFromExternal, [id]);
    _this.searchParams();
    return _this;
  }
  _inherits(LeadFromExternal, _lm$Composant);
  return _createClass(LeadFromExternal, [{
    key: "searchParams",
    value: function searchParams() {
      var urlParams = new URLSearchParams(window.location.search);
      var agency = urlParams.get('prescribingAgency');
      var company = urlParams.get('prescribingCompany');
      if (agency !== null) {
        localStorage.setItem('trek:prescribingAgency', agency);
      }
      if (company !== null) {
        localStorage.setItem('trek:prescribingCompany', company);
      }
    }
  }]);
}(lm.Composant);
lm.DOMReady(function () {
  try {
    new LeadFromExternal('leadfromexternal');
  } catch (error) {
    console.error("error ".concat(error));
  }
});
export default LeadFromExternal;